/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/4/2022.
 */

import React from 'react'
import {FormattedMessage} from 'react-intl';
import {Grid, Pagination} from '@scuf/common';
import FaultCard from './FaultCard'
import FaultsFilter from './FaultsFilter'

class FaultCards extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const faultCards = this.props.faults.map(f =>
            <Grid.Column key={f.id} width={4} sWidth={12}><FaultCard fault={f}/></Grid.Column>);

        return (
            <div>
                <FaultsFilter {...this.props} className="faults-filter"/>
                <Grid>
                    <Grid.Row>
                        {faultCards.length === 0 && !this.props.loading
                            ? <Grid.Column size={12}><FormattedMessage id="faults.results.empty"/></Grid.Column>
                            : faultCards}
                    </Grid.Row>
                    <Pagination
                        totalItems={this.props.totalCount}
                        activePage={this.props.start + 1}
                        itemsPerPage={this.props.limit}
                        boundaryRange={3}
                        itemsPerPageOptions={[12, 24, 48]}
                        onPageChange={(page, cardsPerPage) =>
                            this.props.parentLoadListMethod(page, cardsPerPage)
                        }
                    />
                </Grid>
            </div>
        )
    }
}


export default FaultCards